import { Tabs, useRouter } from 'expo-router';
import { useEffect } from 'react';

import { renderAppBottomBar } from '@/components/organisms/navigation/AppBottomBar';
import { useAuthStore } from '@/stores';

const TabsLayout = () => {
  const router = useRouter();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!isAuthenticated) {
      router.replace('/');
    }
  }, [isAuthenticated, isLoading, router]);

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Tabs tabBar={renderAppBottomBar}>
      <Tabs.Screen name="meetings" options={{ headerShown: false }} />
      <Tabs.Screen name="ai-tasks" options={{ headerShown: false }} />
      <Tabs.Screen name="settings" options={{ headerShown: false }} />
    </Tabs>
  );
};

export default TabsLayout;
